// src/Home.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import { fetchAllEvents } from '../FirebaseService';
import './Home.css';

import bg0 from './assets/background.jpg';
import bg1 from './assets/background1.png';
import bg2 from './assets/background2.png';
import sec2Bg from './assets/sec2bg1.png';

const HomePage = () => {
  const navigate = useNavigate();
  const [upcomingEvents, setUpcomingEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [timeLeft, setTimeLeft] = useState({});

  const bgImages = [bg0, bg1, bg2];
  const [currentBgIndex, setCurrentBgIndex] = useState(0);

  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = '/logo.png';
  };

  const handleParentClick = () => {
    navigate('/parent');
  };

  // Điều hướng đến trang Ăn gì hôm nay
  const handleFoodClick = () => {
    navigate('/an-gi-hom-nay');
  };

  const parseDate = (dateStr) => {
    if (!dateStr) return new Date();
    const [day, month, year] = dateStr.split('/');
    return new Date(year, month - 1, day);
  };

  useEffect(() => {
    const bgTimer = setInterval(() => {
      setCurrentBgIndex((prevIndex) => (prevIndex + 1) % bgImages.length);
    }, 4000);
    return () => clearInterval(bgTimer);
  }, [bgImages.length]);

  useEffect(() => {
    const calculateTimeLeft = () => {
      const eventDate = new Date('2026-12-25T00:00:00');
      const now = new Date();
      const difference = eventDate - now;
      let time = {};
      if (difference > 0) {
        time = {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        };
      }
      return time;
    };

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    const loadEvents = async () => {
      try {
        const events = await fetchAllEvents();
        const currentDate = new Date(2025, 7, 13);
        const filteredEvents = (events || []).filter(
          (event) => parseDate(event.date) > currentDate
        );
        setUpcomingEvents(filteredEvents);
      } catch (err) {
        console.error("Lỗi khi tải sự kiện:", err);
      } finally {
        setLoading(false);
      }
    };
    loadEvents();

    return () => clearInterval(timer);
  }, []);

  if (loading) {
    return (
      <div className="lghome-loading-screen">
        <div className="lghome-loading-wrapper">
          <div className="lghome-loading-spinner"></div>
          <img src="/logo.png" alt="Loading..." className="lghome-loading-logo" />
        </div>
      </div>
    );
  }

  return (
    <div className="lghome-wrapper">
      <Navbar />

      <div className="lghome-blob lghome-blob-1"></div>
      <div className="lghome-blob lghome-blob-2"></div>
      <div className="lghome-blob lghome-blob-3"></div>

      <div className="lghome-main-container">

        {/* SECTION 1: HERO */}
        <header className="lghome-hero-section">
          {bgImages.map((img, index) => (
            <div
              key={index}
              className={`lghome-hero-bg ${index === currentBgIndex ? 'active' : ''}`}
              style={{ backgroundImage: `url(${img})` }}
            />
          ))}
          <div className="lghome-hero-overlay"></div>

          <div className="lghome-hero-content">
            <div className="lghome-logo-glass">
              <img
                src="/logo.png"
                alt="Logo Thiếu Nhi An Nhơn"
                className="lghome-hero-logo"
                onError={handleImageError}
              />
            </div>
            <h1 className="lghome-hero-title">
              Trường Giáo Lý Thiếu Nhi <br />
              <span className="lghome-highlight-text">Giáo Xứ An Nhơn</span>
            </h1>
            <p className="lghome-hero-subtitle">
              Hiệp Nhất - Yêu Thương - Phục Vụ
            </p>
          </div>

          <div className="lghome-carousel-dots">
            {bgImages.map((_, idx) => (
              <span
                key={idx}
                className={`lghome-dot ${idx === currentBgIndex ? 'active' : ''}`}
                onClick={() => setCurrentBgIndex(idx)}
              ></span>
            ))}
          </div>
        </header>

        {/* SECTION 2: DÀNH CHO PHỤ HUYNH */}
        <section 
          className="lghome-section lghome-parent-section"
          style={{ backgroundImage: `url(${sec2Bg})` }}
        >
          <div className="lghome-section-glass">
            <div className="lghome-badge">Dành cho Phụ Huynh</div>
            <h2>Tra Cứu Thông Tin Thiếu Nhi</h2>
            <p>
              Quý Phụ huynh có thể tra cứu nhanh điểm số, tình hình chuyên cần và thông báo từ Đoàn Thiếu Nhi.
            </p>
            <button onClick={handleParentClick} className="lghome-parent-button">
              🔍 Tra cứu ngay
            </button>
          </div>
        </section>

        {/* SECTION 3: GIỚI THIỆU */}
        <section className="lghome-section lghome-about-section">
          <div className="lghome-section-glass">
            <h2>🎈 Giới Thiệu Trường Giáo Lý</h2>
            <p>
              Trường Giáo Lý Thiếu Nhi An Nhơn là ngôi nhà thân thương nơi các em nhỏ cùng học hỏi về Chúa Giê-su, Kinh Thánh và rèn luyện lối sống đạo đức hàng ngày. Thông qua các buổi học sinh động và các hoạt động ngoại khóa vui nhộn, chúng tôi đồng hành cùng các em lớn lên trong tình yêu thương của Chúa và Giáo hội.
            </p>
          </div>
        </section>

        {/* SECTION 4: GIỜ LỄ */}
        <section className="lghome-section lghome-schedule-section">
          <div className="lghome-section-glass">
            <h2>⏰ Giờ Lễ Giáo Xứ</h2>
            <p className="lghome-schedule-intro">
              Kính mời quý cộng đoàn và các em thiếu nhi tham dự Thánh Lễ theo lịch dưới đây:
            </p>
            <div className="lghome-table-wrapper">
              <table className="lghome-schedule-table">
                <thead>
                  <tr>
                    <th>Ngày trong tuần</th>
                    <th>Các Ca Lễ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="lghome-highlight-row">
                    <td><strong>Chúa Nhật</strong></td>
                    <td>
                      <span className="lghome-time-tag">05:00</span>
                      <span className="lghome-time-tag">06:30</span>
                      <span className="lghome-time-tag special">08:00 (Lễ Thiếu Nhi)</span>
                      <span className="lghome-time-tag">15:30</span>
                      <span className="lghome-time-tag">17:00</span>
                      <span className="lghome-time-tag">18:30</span>
                    </td>
                  </tr>
                  <tr>
                    <td><strong>Thứ Hai đến Thứ Bảy</strong></td>
                    <td>
                      <span className="lghome-time-tag">04:45</span>
                      <span className="lghome-time-tag">18:00</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="lghome-schedule-note">
              📌 <i>Lưu ý: Giờ Lễ có thể thay đổi tùy theo các dịp Lễ Trọng hoặc thông báo đột xuất từ Cha Chánh Xứ.</i>
            </p>
          </div>
        </section>

        {/* SECTION MỚI: ĂN GÌ HÔM NAY? */}
        <section className="lghome-section lghome-food-section">
          <div className="lghome-section-glass lghome-food-glass">
            <div className="lghome-food-badge">🎲 Vòng Quay Ẩm Thực</div>
            <h2>🍜 Hôm Nay Ăn Gì?</h2>
            <p>
              Đang phân vân không biết ăn gì cùng bạn bè và gia đình? Hãy để vòng quay ngẫu nhiên chọn giúp bạn một món ngon siêu hấp dẫn ngay bây giờ!
            </p>
            <div className="lghome-food-icons">
              <span>🍕</span>
              <span>🍲</span>
              <span>🍱</span>
              <span>🧋</span>
              <span>🍛</span>
            </div>
            <button onClick={handleFoodClick} className="lghome-food-button">
              ✨ Bấm để chọn món ngay!
            </button>
          </div>
        </section>

        {/* FOOTER */}
        <footer className="lghome-footer">
          <div className="lghome-footer-glass">
            <p>&copy; {new Date().getFullYear()} Trường Giáo Lý Thiếu Nhi Giáo Xứ An Nhơn.</p>
            <p className="lghome-subfooter">Yêu thương – Phục vụ – Hy vọng</p>
          </div>
        </footer>

      </div>
    </div>
  );
};

export default HomePage;